import React from "react";
import KeywordsTag from './KeywordsTag';
import { getImageUrl as getImageUrlText } from '../../utils/imageUtilsText';

const Thoughts = ({ yearsIsVisible, monthsIsVisible, keywordsIsVisible }) => (
    <KeywordsTag
        tagId="textPublic"
        handwritingSrc="../../content/handwriting/thoughts.png"
        handwritingAlt="thoughts"
        getUrlFn={getImageUrlText}
        fixedViewerClassName="fixed-image-viewer-text"
        yearsIsVisible={yearsIsVisible}
        monthsIsVisible={monthsIsVisible}
        keywordsIsVisible={keywordsIsVisible}
    />
);

export default Thoughts;